import React, {PureComponent} from "react"
import {connect} from "react-redux"
import styled from "styled-components"
import {
    number,
    dashboardLocalization,
    commonLocalization,
} from "../../../localization"
import LayeredBarChart from "./ward-layered-bar-chart"

import {
    Heading,
    Text,
} from "../../styled"
import {withRouter} from "react-router-dom"
import { images } from "../../../config/index";
import NoData from "../noData"

class WardChart extends PureComponent {
    handleClick = data => {
        const procurementType = data.procurement_type.split(" ").join("_")
        this.props.history.push({
            pathname: "/projects",
            search: `?procurement_type=${procurementType}&fiscal-year=${this.props.fiscalYear}`,
        })
    }

    render() {
        const {selectedLanguage, projectType,chartHelpText, chartTitle, selectedWard} = this.props
        const xLabel = dashboardLocalization[selectedLanguage].barChartLabel
        const yLabel = dashboardLocalization[selectedLanguage].barChartLabelY
        const chartData = []

     if (projectType === "local-project") {
            if (this.props.localProjectData && this.props.localProjectData.projects_count_by_ward) {
                this.props.localProjectData.projects_count_by_ward.forEach(ward => {
                  if (ward.value > 0) {
                    chartData.push({
                      ward: ward.ward,
                      project_count: ward.value,
                    });
                  }
                })
            }
        } else {
            const wardObj = this.props.data.projectsStats.data.data.ward_wise || {}
            
            if (Object.keys(wardObj).length) {
                if (selectedWard === "all") {
                    for (let key in wardObj) {
                        if(key !== 'undefined') {
                            chartData.push({
                                ward: Number(key),
                                project_count: wardObj[key].total.count,
                            })
                        }
                    }
                } else {
                    if (selectedWard.toString() in wardObj) {
                        chartData.push({
                            ward: Number(selectedWard),
                            project_count: wardObj[selectedWard].total.count
                        })
                    }
                }
            }
        }

        const { projects, project } = commonLocalization[selectedLanguage];

        return (
          <ChartsBlock className={"flex flex-col"} lang={selectedLanguage}>
            <Heading.h2 uppercase className="chart-label flex items-center">
              <Text.span className="help-text">
                <Text.span className="help-text__icon">
                  <img
                    className="help-icon"
                    height={18}
                    width={18}
                    src={images.icons.help}
                    alt="help"
                  />
                </Text.span>
                <Text.span className="help-text__content tooltip">
                  <Text.span className="tooltip-arrow">arrow</Text.span>
                  {chartHelpText}
                </Text.span>
              </Text.span>
              <Text.span className="chart-title">{chartTitle}</Text.span>
            </Heading.h2>

            <div className="card--chart charts-block ward-chart flex-1 flex items-center">
              <div className={"w-full layer-bar-chart"}>
                {chartData.length ? (
                  <LayeredBarChart
                    projectType={projectType}
                    xKey="ward"
                    yKey="project_count"
                    y1Key="project_count"
                    xLabel={xLabel}
                    yLabel={yLabel}
                    chartData={chartData}
                    onClick={(datum) => this.handleClick(datum)}
                    tooltip={({ ward, project_count }) => {
                      return (
                        <div
                          className={
                            projectType === "social"
                              ? "tooltip tooltip--social"
                              : "tooltip"
                          }
                        >
                          <div className="tooltip-arrow" />
                          <div>
                            {number(project_count)}{" "}
                            {project_count < 2 ? project : projects}
                          </div>
                        </div>
                      );
                    }}
                  ></LayeredBarChart>
                ) : <NoData selectedLanguage={selectedLanguage} />}
              </div>
            </div>
          </ChartsBlock>
        );
    }
}

const ChartsBlock = styled.div`
            h2 {
            font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
            > span:last-child {
            font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
            opacity: 0.7;
            }
            }
            .help-text__content {
            font-size: ${props => (props.lang === "en" ? "11px" : "13px")};
            }
            `

export default withRouter(
    connect(state => ({
        selectedLanguage: state.localizationReducers.selectedLanguage,
        selectedWard: state.projectsStatsReducers.selectedWard,
        overall: state.projectsStatsReducers.data.data.overall,
        procurement_type: state.projectsStatsReducers.data.data.procurement_type,
        fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
    }))(WardChart),
)



// WEBPACK FOOTER //
// ./src/components/layouts/WardChart/WardChart.js